module.exports = __webpack_public_path__ + "static/media/enterprises-icon-1.7145175f.svg";